const tinymceConfig = {
  height: 400,
  menubar: "file edit view insert format tools table help",
  plugins: [
    "advlist", "autolink", "lists", "link", "charmap", "preview", "anchor",
    "searchreplace", "visualblocks", "code", "fullscreen",
    "insertdatetime", "media", "table", "help", "wordcount"
  ],
  toolbar:
    "undo redo | formatselect | " +
    "bold italic underline strikethrough | alignleft aligncenter " +
    "alignright alignjustify | bullist numlist outdent indent | " +
    "fontsize fontfamily forecolor backcolor | table | removeformat",
  fontsize_formats: "10px 12px 14px 16px 18px 24px 36px 48px",
  font_family_formats:
    "Arial=arial,helvetica,sans-serif;" +
    "Courier New=courier new,courier,monospace;" +
    "Georgia=georgia,palatino;" +
    "Tahoma=tahoma,arial,helvetica,sans-serif;" +
    "Times New Roman=times new roman,times;" +
    "Verdana=verdana,geneva;",
};

export default tinymceConfig;
